import Bookmarks from "../Pages/Applications/Bookmarks";
import Calendar from "../Pages/Applications/Calendar";
import GroupChat from "../Pages/Applications/Chat/GroupChat";
import PrivateChat from "../Pages/Applications/Chat/PrivateChat";
import Contacts from "../Pages/Applications/Contacts";
import AddProduct from "../Pages/Applications/ECommerce/AddProduct";
import Cart from "../Pages/Applications/ECommerce/Cart";
import Checkout from "../Pages/Applications/ECommerce/Checkout";
import Invoice6 from "../Pages/Applications/ECommerce/Invoice/Invoice6";
import OrderHistory from "../Pages/Applications/ECommerce/OrderHistory";
import PaymentDetails from "../Pages/Applications/ECommerce/PaymentDetails";
import Pricing from "../Pages/Applications/ECommerce/Pricing";
import Product from "../Pages/Applications/ECommerce/Product";
import ProductList from "../Pages/Applications/ECommerce/ProductList/ProductListContainer";
import ProductPage from "../Pages/Applications/ECommerce/ProductPage";
import Wishlist from "../Pages/Applications/ECommerce/Wishlist";
import FileManager from "../Pages/Applications/FileManager";
import LetterBox from "../Pages/Applications/LetterBox/Index";
import CreateNew from "../Pages/Applications/Project/CreateNew";
import ProjectList from "../Pages/Applications/Project/ProjectList/index";
import SearchResult from "../Pages/Applications/SearchResult";
import SocialApp from "../Pages/Applications/SocialApp";
import Task from "../Pages/Applications/Task";
import ToDo from "../Pages/Applications/ToDo";
import EditProfile from "../Pages/Applications/Users/EditProfile";
import UsersCard from "../Pages/Applications/Users/UsersCard";
import UsersProfile from "../Pages/Applications/Users/UsersProfile";
import BasicCard from "../Pages/BonusUi/BasicCard";
import Breadcrumb from "../Pages/BonusUi/Breadcrumb";
import CreativeCard from "../Pages/BonusUi/CreativeCard";
import Dropzone from "../Pages/BonusUi/Dropzone";
import ImageCropper from "../Pages/BonusUi/ImageCropper";
import Pagination from "../Pages/BonusUi/Pagination";
import RangeSlider from "../Pages/BonusUi/RangeSlider";
import Rating from "../Pages/BonusUi/Rating";
import Ratios from "../Pages/BonusUi/Ratios";
import Carousel from "../Pages/BonusUi/Carousel";
import Ribbons from "../Pages/BonusUi/Ribbons";
import Scrollable from "../Pages/BonusUi/Scrollable";
import SweetAlert from "../Pages/BonusUi/SweetAlert";
import TimeLine from "../Pages/BonusUi/TimeLine";
import Toasts from "../Pages/BonusUi/Toasts";
import Tour from "../Pages/BonusUi/Tour";
import Tree from "../Pages/BonusUi/Tree";
import ButtonGroup from "../Pages/Button/ButtonGroup";
import DefaultStyle from "../Pages/Button/DefaultStyle";
import ApexChart from "../Pages/Charts/ApexChart";
import ChartJs from "../Pages/Charts/ChartJs";
import GoogleChart from "../Pages/Charts/GoogleChart";
import BaseInput from "../Pages/Forms&Table/Forms/FormControls/BaseInput";
import CheckBoxAndRadio from "../Pages/Forms&Table/Forms/FormControls/CheckboxAndRadio";
import FormValidation from "../Pages/Forms&Table/Forms/FormControls/FormValidation";
import InputGroup from "../Pages/Forms&Table/Forms/FormControls/InputGroup";
import InputMark from "../Pages/Forms&Table/Forms/FormControls/InputMark";
import MegaOptions from "../Pages/Forms&Table/Forms/FormControls/MegaOptions";
import FormWizard1 from "../Pages/Forms&Table/Forms/FormLayout/FormWizard1";
import FormWizard2 from "../Pages/Forms&Table/Forms/FormLayout/FormWizard2";
import TwoFactor from "../Pages/Forms&Table/Forms/FormLayout/Twofactor";
import Clipboard from "../Pages/Forms&Table/Forms/FormWidgets/Clipboard";
import DatePicker from "../Pages/Forms&Table/Forms/FormWidgets/DatePicker";
import Switch from "../Pages/Forms&Table/Forms/FormWidgets/Switch";
import Touchspin from "../Pages/Forms&Table/Forms/FormWidgets/Touchspin";
import Typeahead from "../Pages/Forms&Table/Forms/FormWidgets/Typeahead";
import AdvanceInit from "../Pages/Forms&Table/Table/DataTables/AdvanceInit";
import Api from "../Pages/Forms&Table/Table/DataTables/Api";
import BasicInit from "../Pages/Forms&Table/Table/DataTables/BasicInit";
import DataSources from "../Pages/Forms&Table/Table/DataTables/DataSources";
import BasicTables from "../Pages/Forms&Table/Table/ReactstrapTables/BasicTables";
import TableComponents from "../Pages/Forms&Table/Table/ReactstrapTables/TableComponents";
import Default from "../Pages/General/Dashboards/Default";
import Ecommerce from "../Pages/General/Dashboards/Ecommerce";
import Chart from "../Pages/General/Widgets/Chart";
import General from "../Pages/General/Widgets/General";
import FeatherIcon from "../Pages/Icon/FeatherIcon";
import FlagIcon from "../Pages/Icon/FlagIcon";
import FontAwesome from "../Pages/Icon/FontAwesome";
import IcoIcon from "../Pages/Icon/IcoIcon";
import ThemifyIcon from "../Pages/Icon/ThemifyIcon";
import WhetherIcon from "../Pages/Icon/WhetherIcon";
import AddPost from "../Pages/Miscellaneous/Blog/AddPost";
import BlogDetails from "../Pages/Miscellaneous/Blog/BlogDetails";
import BlogGrids from "../Pages/Miscellaneous/Blog/BlogGrids";
import AceCodeEditor from "../Pages/Miscellaneous/Editors/AceCodeEditor";
import CkEditors from "../Pages/Miscellaneous/Editors/CkEditor";
import MdeEditor from "../Pages/Miscellaneous/Editors/MdeEditor";
import FAQ from "../Pages/Miscellaneous/FAQ";
import GalleryDescription from "../Pages/Miscellaneous/Gallery/GalleryDescription";
import GalleryGrid from "../Pages/Miscellaneous/Gallery/GalleryGrid";
import GalleryHover from "../Pages/Miscellaneous/Gallery/GalleryHover";
import MasonryDescription from "../Pages/Miscellaneous/Gallery/MasonryDescription";
import MasonryGallery from "../Pages/Miscellaneous/Gallery/MasonryGallery";
import CardsView from "../Pages/Miscellaneous/JobSearch/CardsView";
import JobApply from "../Pages/Miscellaneous/JobSearch/JobApply";
import JobDetails from "../Pages/Miscellaneous/JobSearch/JobDetails";
import ListView from "../Pages/Miscellaneous/JobSearch/ListView";
import Knowledgebase from "../Pages/Miscellaneous/Knowledgebase";
import CourseDetails from "../Pages/Miscellaneous/Learning/CourseDetails";
import LearningList from "../Pages/Miscellaneous/Learning/LearningList";
import GoogleMap from "../Pages/Miscellaneous/Maps/GoogleMap";
import LeafletMap from "../Pages/Miscellaneous/Maps/LeafletMap";
import SupportTicket from "../Pages/Miscellaneous/SupportTicket";
import SamplePage from "../Pages/Pages/SamplePage";
import Accordion from "../Pages/UiKits/Accordion";
import Alert from "../Pages/UiKits/Alert";
import Avatars from "../Pages/UiKits/Avatars";
import Divider from "../Pages/UiKits/Divider";
import Dropdown from "../Pages/UiKits/Dropdown";
import Grid from "../Pages/UiKits/Grid";
import HelperClasses from "../Pages/UiKits/HelperClasses";
import Lists from "../Pages/UiKits/Lists";
import Modal from "../Pages/UiKits/Modal";
import NavigateLinks from "../Pages/UiKits/NavigateLinks";
import Offcanvas from "../Pages/UiKits/Offcanvas";
import Placeholders from "../Pages/UiKits/Placeholders";
import Popover from "../Pages/UiKits/Popover";
import ProgressBar from "../Pages/UiKits/ProgressBar";
import Tabs from "../Pages/UiKits/Tabs";
import TagAndPills from "../Pages/UiKits/Tag&Pills";
import Tooltip from "../Pages/UiKits/Tooltip";
import Typography from "../Pages/UiKits/Typography";

export const routes = [
  //General
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, element: <Default /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`, element: <Ecommerce /> },
  { path: `${process.env.PUBLIC_URL}/widgets/general-widget`, element: <General /> },
  { path: `${process.env.PUBLIC_URL}/widgets/chart-widget`, element: <Chart /> },
  //Application
  { path: `${process.env.PUBLIC_URL}/applications/project/create-new`, element: <CreateNew /> },
  { path: `${process.env.PUBLIC_URL}/applications/project/project-list`, element: <ProjectList /> },
  { path: `${process.env.PUBLIC_URL}/applications/file-manager`, element: <FileManager /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/product`, element: <Product /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/add-products`, element: <AddProduct /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/product-list`, element: <ProductList /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/payment-details`, element: <PaymentDetails /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/order-history`, element: <OrderHistory /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/wishlist`, element: <Wishlist /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/pricing`, element: <Pricing /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/product-page`, element: <ProductPage /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/cart`, element: <Cart /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/checkout`, element: <Checkout /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/invoice/invoice-6`, element: <Invoice6 /> },
  { path: `${process.env.PUBLIC_URL}/applications/email/letter-box`, element: <LetterBox /> },
  { path: `${process.env.PUBLIC_URL}/applications/chat/group-chat`, element: <GroupChat /> },
  { path: `${process.env.PUBLIC_URL}/applications/chat/private-chat`, element: <PrivateChat /> },
  { path: `${process.env.PUBLIC_URL}/applications/users/user-profile`, element: <UsersProfile /> },
  { path: `${process.env.PUBLIC_URL}/applications/users/edit-profile`, element: <EditProfile /> },
  { path: `${process.env.PUBLIC_URL}/applications/users/user-cards`, element: <UsersCard /> },
  { path: `${process.env.PUBLIC_URL}/applications/bookmark`, element: <Bookmarks /> },
  { path: `${process.env.PUBLIC_URL}/applications/contacts`, element: <Contacts /> },
  { path: `${process.env.PUBLIC_URL}/applications/task`, element: <Task /> },
  { path: `${process.env.PUBLIC_URL}/applications/calendar`, element: <Calendar /> },
  { path: `${process.env.PUBLIC_URL}/applications/social-app`, element: <SocialApp /> },
  { path: `${process.env.PUBLIC_URL}/applications/to-do`, element: <ToDo /> },
  { path: `${process.env.PUBLIC_URL}/applications/search-result`, element: <SearchResult /> },
  //Forms & Tables
  { path: `${process.env.PUBLIC_URL}/forms/form-controls/form-validation`, element: <FormValidation /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-controls/base-input`, element: <BaseInput /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-controls/radio-&-checkbox`, element: <CheckBoxAndRadio /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-controls/input-group`, element: <InputGroup /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-controls/input-mask`, element: <InputMark /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-controls/mega-options`, element: <MegaOptions /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/datepicker`, element: <DatePicker /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/touchspin`, element: <Touchspin /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/switch`, element: <Switch /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/typeahead`, element: <Typeahead /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/clipboard`, element: <Clipboard /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-layout/form-wizard-1`, element: <FormWizard1 /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-layout/form-wizard-2`, element: <FormWizard2 /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-layout/two-factor`, element: <TwoFactor /> },
  { path: `${process.env.PUBLIC_URL}/table/reactstrap-tables/basic-table`, element: <BasicTables /> },
  { path: `${process.env.PUBLIC_URL}/table/reactstrap-tables/table-components`, element: <TableComponents /> },
  { path: `${process.env.PUBLIC_URL}/table/data-tables/basic-init`, element: <BasicInit /> },
  { path: `${process.env.PUBLIC_URL}/table/data-tables/advance-init`, element: <AdvanceInit /> },
  { path: `${process.env.PUBLIC_URL}/table/data-tables/api`, element: <Api /> },
  { path: `${process.env.PUBLIC_URL}/table/data-tables/data-sources`, element: <DataSources /> },
  //Component
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/tabs`, element: <Tabs /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/dropdown`, element: <Dropdown /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/accordion`, element: <Accordion /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/popover`, element: <Popover /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/tooltip`, element: <Tooltip /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/lists`, element: <Lists /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/modal`, element: <Modal /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/progress-bar`, element: <ProgressBar /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/alert`, element: <Alert /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/grid`, element: <Grid /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/tag-pills`, element: <TagAndPills /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/avatars`, element: <Avatars /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/helper-classes`, element: <HelperClasses /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/typography`, element: <Typography /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/placeholders`, element: <Placeholders /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/divider`, element: <Divider /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/navigate-links`, element: <NavigateLinks /> },
  { path: `${process.env.PUBLIC_URL}/components/ui-kits/offcanvas`, element: <Offcanvas /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/scrollable`, element: <Scrollable /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/timeline`, element: <TimeLine /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/image-cropper`, element: <ImageCropper /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/basic-card`, element: <BasicCard /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/creative-card`, element: <CreativeCard /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/carousel`, element: <Carousel /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/ratios`, element: <Ratios /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/ribbons`, element: <Ribbons /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/pagination`, element: <Pagination /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/breadcrumb`, element: <Breadcrumb /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/range-slider`, element: <RangeSlider /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/sweet-alert-2`, element: <SweetAlert /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/tree`, element: <Tree /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/toasts`, element: <Toasts /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/dropzone`, element: <Dropzone /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/tour`, element: <Tour /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus-ui/rating`, element: <Rating /> },
  { path: `${process.env.PUBLIC_URL}/components/charts/apex-chart`, element: <ApexChart /> },
  { path: `${process.env.PUBLIC_URL}/components/charts/google-chart`, element: <GoogleChart /> },
  { path: `${process.env.PUBLIC_URL}/components/charts/chartjs`, element: <ChartJs /> },
  { path: `${process.env.PUBLIC_URL}/components/button/default-style`, element: <DefaultStyle /> },
  { path: `${process.env.PUBLIC_URL}/components/button/button-group`, element: <ButtonGroup /> },
  { path: `${process.env.PUBLIC_URL}/components/icons/flag-icon`, element: <FlagIcon /> },
  { path: `${process.env.PUBLIC_URL}/components/icons/font-awesome`, element: <FontAwesome /> },
  { path: `${process.env.PUBLIC_URL}/components/icons/ico-icon`, element: <IcoIcon /> },
  { path: `${process.env.PUBLIC_URL}/components/icons/themify-icon`, element: <ThemifyIcon /> },
  { path: `${process.env.PUBLIC_URL}/components/icons/feather-icon`, element: <FeatherIcon /> },
  { path: `${process.env.PUBLIC_URL}/components/icons/whether-icon`, element: <WhetherIcon /> },
  //Page
  { path: `${process.env.PUBLIC_URL}/pages/sample-page`, element: <SamplePage /> },
  //Miscellaneous
  { path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/grid-gallery`, element: <GalleryGrid /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/grid-gallery-description`, element: <GalleryDescription /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/masonry-gallery`, element: <MasonryGallery /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/masonry-gallery-description`, element: <MasonryDescription /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/gallery-hover`, element: <GalleryHover /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/blog/blog-grids`, element: <BlogGrids /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/blog/blog-details`, element: <BlogDetails /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/blog/add-post`, element: <AddPost /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/faq`, element: <FAQ /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/knowledgebase`, element: <Knowledgebase /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/support-ticket`, element: <SupportTicket /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/job-search/job-list-view`, element: <ListView /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/job-search/job-details`, element: <JobDetails /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/job-search/job-apply`, element: <JobApply /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/job-search/job-cards-view`, element: <CardsView /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/learning/learning-list-view`, element: <LearningList /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/learning/course-details`, element: <CourseDetails /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/maps/google-map`, element: <GoogleMap /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/maps/leaflet-map`, element: <LeafletMap /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/editors/ck-editor`, element: <CkEditors /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/editors/mde-editor`, element: <MdeEditor /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/editors/ace-code-editor`, element: <AceCodeEditor /> },
];
